import { Autocomplete, TextField } from "@mui/material";

import { getDropdownCategoryLabel } from "@/pages/system-settings/tabs/dropdowns/DropdownsSettings.utils";
import { useSortedCategories } from "@/pages/system-settings/tabs/dropdowns/hooks/useSortedCategories";
import { useTranslation } from "@/translations";

export function CategorySelect() {
  const { t } = useTranslation();
  const { sortedCategories, selectedCategory, setSelectedCategory } = useSortedCategories();

  return (
    <Autocomplete
      value={selectedCategory}
      onChange={(_, newValue) => setSelectedCategory(newValue)}
      options={sortedCategories}
      getOptionLabel={(option) => getDropdownCategoryLabel(option, t)}
      disableClearable
      size="small"
      fullWidth
      renderInput={(params) => <TextField {...params} label={t("settings.dropdowns.selectDropdown")} />}
    />
  );
}
